import { render, staticRenderFns } from "./EditTab.vue?vue&type=template&id=95f25cf6"
import script from "./EditTab.vue?vue&type=script&lang=js"
export * from "./EditTab.vue?vue&type=script&lang=js"
import style0 from "./EditTab.vue?vue&type=style&index=0&id=95f25cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports